<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="提问人：">
            <el-input v-model="query.userRealName" placeholder="请输入提问人姓名" clearable size="small" />
          </el-form-item>
          <!-- <el-form-item label="身份：">
          </el-form-item> -->
          <el-form-item label="手机号：">
            <el-input v-model="query.userMobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="咨询问题：">
            <el-input v-model="query.content" placeholder="请输入咨询问题" clearable size="small" />
          </el-form-item>
          <el-form-item label="处理状态：">
            <el-select v-model="query.status" placeholder="请选择" clearable size="small">
              <el-option label="待处理" :value="10"></el-option>
              <el-option label="已回复" :value="20"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="咨询问题" name="1"></el-tab-pane>
          <el-tab-pane label="待回复" name="2"></el-tab-pane>
          <el-tab-pane label="已回复" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="提问人" prop="userRealName" align="center" width="200" fixed />
        <el-table-column label="身份" prop="userLevelName" align="center" />
        <el-table-column label="提问人手机号" prop="userMobile" align="center" />
        <el-table-column label="咨询问题" prop="replyContent" align="center" />
        <el-table-column label="提问时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="处理状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            {{row.status === 10?'待处理':'已回复'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['customer:problem:reply']">回复</el-button>
            <el-button type="text" @click="handleService(row)" v-if="row.custServiceStaffId" v-hasPermi="['customer:problem:service']">指定客服</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <problem-add ref="problemAdd" @created="doQueryList({})" />
    <problem-service ref="problemService" @created="doQueryList({})" />

  </div>
</template>

<script>
import problemAdd from './add.vue'
import problemService from './service.vue'
import custServiceGuestbookApi from '@/api/customer/custServiceGuestbook'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
    problemAdd,
    problemService
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        userRealName: undefined,
        userMobile: undefined,
        status: undefined,
        content: undefined,
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.isGetNotCustServiceStaffId = this.activeName === '1' ? true : undefined
      this.query.status = this.activeName === '2' ? 10 : (this.activeName === '3' ? 20 : undefined)
      this.listLoading = true
      return custServiceGuestbookApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceGuestbookApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceGuestbookApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      custServiceGuestbookApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.problemAdd.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.problemAdd.handleUpdate(row)
    },
    handleService(row) {
      this.$refs.problemService.handleService(row)

    }
  }
}
</script>
<style lang="scss" scoped>
.coutomer-time {
  i {
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
    padding-left: 5px;
  }
}
</style>